<div class="content">
  <div class="content-inner">
    <div>
      <ppl-icon [svgIcon]="icon"
                width="80px"
                height="80px"></ppl-icon>
      <div class="title">{{title}}</div>
      <a *ngIf="actionLink"
         class="action-button"
         href="{{actionLink}}"
         target="_blank"
         pplButton
         pplButton1
         pplButtonBold
         pplButtonLarge>{{actionText}}</a>
      <div class="subtitle">{{subtitle}} <a *ngIf="isTrialExpired" href="mailto:sales@pipelinersales.com"
                                            target="_blank"> sales&#64;pipelinersales.com</a></div>
    </div>
  </div>
</div>
